<template>
  <div className="flex justify-between items-end">
    <TwcLabel class="!text-xl"> {{ i18n.total }} </TwcLabel>
    <TwcLabel class="!text-3xl"> ${{ orderStore.total.toFixed(2) }} </TwcLabel>
  </div>
</template>

<script setup lang="ts">
import { TwcLabel } from 'transit-web-components'
import { useOrderStore } from '@/stores/order'

const orderStore = useOrderStore()
const i18n = {
  total: 'Total'
}
</script>

<style></style>
